import {createStore} from 'vuex'
import createPersistedState from 'vuex-persistedstate';

import layout from './modules/layout';
import menu from './modules/menu';
import chat from './modules/chat';
import product from './modules/product';
import todo from './modules/todo';
import contact from './modules/contact';
import jobs from './modules/jobs';
import courses from './modules/courses';
import common from './modules/common';
import tags from './modules/tags';
import bootsrap from "./modules/bootsrap"
import language from "./modules/language"
import pendingRequests from './modules/pendingRequests';


export default createStore({
  state:{langIcon: '',langLangauge: '',isActive:false,
  name: localStorage.getItem('name') || '',
  email: localStorage.getItem('email') || '',
  token: localStorage.getItem('authToken') || '',
  actor: localStorage.getItem('actor') || ''},
  getters:{
    langIcon: (state)=>{ return state.langIcon},
    langLangauge:(state)=>{return state.langLangauge}
  },
  mutations: {
      changeLang (state, payload) {
        localStorage.setItem('currentLanguage', payload.id);
        localStorage.setItem('currentLanguageIcon', payload.icon);
        state.langIcon = payload.icon || 'flag-icon-us'
        state.langLangauge = payload.id || 'EN'
      },  setUserInfo(state, user) {
        state.name = user.name;
        state.email = user.email;
        state.token = user.token;
        state.actor = user.actor || 'Employer';
      },
      clearUserInfo(state) {
        state.name = '';
        state.email = '';
        state.token = '';
        state.actor = '';
      },
      change(state){
        state.isActive = !state.isActive
      }
    },
    plugins: [createPersistedState({
      reducer: (state) => {
        const persistedState = { ...state };
        delete persistedState.pendingRequests;
        return persistedState;
      },
    })],
    actions: {
      setLang ({ commit }, payload) {
        commit('changeLang', payload);  
        
      }
    },
    modules: {
      layout,
      chat,
      menu,
      product,
      todo,
    tags,
      jobs,
      courses,language,
      common,contact,bootsrap,pendingRequests
    }
});
